import { useMemo } from 'react';
import '../../internals/89afd3114d9c158f62e0e21a82cf39c4eddcf7acec690559797227aa316f9264.cfe-internal.js';
import { useDragDropManager } from '../2c2a08c7de500853fb7e7fc6c23b7488305aacbb55475e14a20fb57649979a77.cfe-internal.js';
import { DropTargetMonitorImpl } from '../../internals/2ef119d0892dd92b6f57c9421e04b1c8f5e591209501bacb977f116f26c53726.cfe-internal.js';

function useDropTargetMonitor() {
  var manager = useDragDropManager();
  return useMemo(function () {
    return new DropTargetMonitorImpl(manager);
  }, [manager]);
}

export { useDropTargetMonitor };
